import React from "react";
import "./FooterStyles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faAddressBook,
  faLocation,
  faLocationArrow,
  faLocationDot,
  faMessage,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faYoutube,
  faTwitter,
  faInstagram,
  faThreads, // Added Threads icon
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom"; // Ensure you have react-router-dom installed
const Footer = () => {
  const linkStyle = {
    color: "#ccc",
    textDecoration: "none",
  };

  return (
    <footer className="footer-section">
      <div className="footer-banner">
        <p>
          Want to Travel the World? Get in Touch with Pearl at{" "}
          <strong>24X7 +91 - 73034 55505</strong>
        </p>
      </div>

      <div className="footer-main">
        <div className="footer-about">
          <p>
            Pearl offers exciting customizable packages to spectacular
            destinations. Pearl aims to create a harmony of travellers and
            industry operatives and streamline the travel process with modern,
            cutting edge technologies.
          </p>
          <p>
            <FontAwesomeIcon
              icon={faPhone}
              style={{ color: "#64192E", marginRight: "6px" }}
            />
            +91- 73034 55505
          </p>
          <p>
            <FontAwesomeIcon
              icon={faEnvelope}
              style={{ color: "#64192E", marginRight: "6px" }}
            />{" "}
            pearltoursandtravelsangli@gmail.com
          </p>
          <p>
            <FontAwesomeIcon
              icon={faMessage}
              style={{ color: "#64192E", marginRight: "6px" }}
            />{" "}
            +91-73034 55505
          </p>
          <p>
            <FontAwesomeIcon
              icon={faLocationDot}
              style={{ color: "#64192E", marginRight: "6px" }}
            />{" "}
            Pearl Enclave, MSEB Rd, next to chai sutta bar, Viya Nagar,
            Vishrambag, Sangli, Sangli Miraj Kupwad, Maharashtra 416415
          </p>
        </div>

        <div className="footer-links">
          <h4>Quick Links</h4>
          <div className="footer-columns">
            <ul>
              <li>Region</li>
              <li>Countries</li>
              <li>Destinations</li>
              <li>Experiences</li>
              <li>Activities</li>
              <li>International Tours</li>
              <li>Domestic Tours</li>
              <li>Group Tours</li>
            </ul>
            <ul>
              <li>Visa</li>
              <li>Contact Us</li>
              <li>FAQs</li>
              <li>Review Us</li>
              <li>Careers</li>
              <li>Presentations</li>
              <li>
                <Link to="/privacypolicy" style={linkStyle}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/termsandconditions" style={linkStyle}>
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-social">
          <h4>Connect with us</h4>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/pearltoursandtravelsangli/about/?_rdr/" // replace with your real URL
              target="_blank"
              rel="noopener noreferrer"
              className="icon facebook"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
              }}
            >
              <FontAwesomeIcon
                icon={faFacebookF}
                style={{ color: "white", margin: "6px" }}
              />
            </a>

            <a
              href="https://www.youtube.com/@pearltourstravelssangli4768/"
              target="_blank"
              rel="noopener noreferrer"
              className="icon youtube"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
              }}
            >
              <FontAwesomeIcon
                icon={faYoutube}
                style={{ color: "white", margin: "6px" }}
              />
            </a>

            <a
              href="https://www.x.com/Pearltt55?t=_Xpt7ZAEt-I9RNlnD1o5WQ&s=09"
              target="_blank"
              rel="noopener noreferrer"
              className="icon twitter"
             style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
              }}
            >
            
                <FontAwesomeIcon
                  icon={faTwitter}
                  style={{ color: "white", margin: "6px" }}
                />
         
            </a>

            <a
              href="https://www.instagram.com/pearl_tours_travels_sangli/" // 🔁 Replace with your actual Instagram URL
              target="_blank"
              rel="noopener noreferrer"
              className="icon instagram"
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
              }}
            >
              <FontAwesomeIcon
                icon={faInstagram}
                style={{ color: "white", margin: "6px" }}
              />
            </a>
            <a
              href="https://www.threads.com/@pearl_tours_travels_sangli"
              target="_blank"
              rel="noopener noreferrer"
              className="icon threads"
             style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                textDecoration: "none",
              }}
            >
            
                <FontAwesomeIcon
                  icon={faThreads}
                  style={{ color: "white", margin: "6px" }}
                />
         
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>Copyright © 2025 , Pearl International</p>
        <p>
          All rights reserved. <span className="link">Terms & Conditions</span>{" "}
          & <span className="link">Privacy Policy</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
